import React from 'react';
import { PhoneIcon, MessageCircleIcon, LockIcon } from 'lucide-react';
import { RestaurantAccessStatus } from '../../lib/access-status';
const SUPPORT_PHONE_DISPLAY = '+506 8811-8105';
const SUPPORT_PHONE_E164 = '50688118105';
interface SuspensionScreenProps {
  status: RestaurantAccessStatus | null;
  restaurantName?: string;
}

/**
 * Pantalla completa de servicio suspendido.
 *
 * Se renderiza EN LUGAR del árbol operativo — nunca encima de él. Cuando
 * esta pantalla está visible, el dashboard, las mesas, la caja, el KDS, el
 * inventario, los reportes y la configuración no existen en el árbol de
 * React, así que no hay datos financieros ni operativos detrás.
 */
export function SuspensionScreen({
  status,
  restaurantName
}: SuspensionScreenProps) {
  // El mensaje puede personalizarse desde la base; si no hay, se usa el
  // texto estándar de NOIZA.
  const customMessage = status?.suspension_message?.trim();
  return <main role="alert" aria-live="assertive" className="min-h-screen w-full bg-brand-offwhite flex items-center justify-center p-6" data-id="element-1790" data-mp="3fr7zuflrw55o">
      <div className="w-full max-w-lg" data-id="element-1791" data-mp="k109t8gui83b">
        <div className="bg-white border border-gray-200 rounded-2xl p-8 sm:p-10 text-center" data-id="element-1792" data-mp="k21jb8i7qmix">
          <div className="w-14 h-14 bg-red-50 rounded-2xl flex items-center justify-center mx-auto mb-7" data-id="element-1793" data-mp="fyda6ldxnivk">
            <LockIcon className="w-7 h-7 text-red-600" aria-hidden="true" data-id="element-1794" data-mp="b0k6bz03r0yg" />
          </div>

          <h1 className="text-2xl sm:text-[28px] leading-tight font-bold tracking-tight text-gray-900 mb-5" data-id="element-1795" data-mp="63bl1pjnqgsz">
            SERVICIO TEMPORALMENTE SUSPENDIDO
          </h1>

          {restaurantName ? <p className="text-sm font-medium text-gray-500 mb-5" data-id="element-1796" data-mp="3shv3pyfo0i59">
              {restaurantName}
            </p> : null}

          {customMessage ? <p className="text-base text-gray-600 leading-relaxed mb-3" data-id="element-1797" data-mp="3jgwtuzijpger">
              {customMessage}
            </p> : <p className="text-base text-gray-600 leading-relaxed mb-3" data-id="element-1798" data-mp="3ei2b1xkkvrun">
              El acceso al sistema se encuentra temporalmente suspendido por
              falta de pago.
            </p>}

          <p className="text-base text-gray-600 leading-relaxed mb-8" data-id="element-1799" data-mp="39ucgb37z0q5z">
            Para restablecer el servicio, favor contactar a soporte.
          </p>

          <a href={`tel:+${SUPPORT_PHONE_E164}`} className="block text-2xl font-bold text-gray-900 tracking-tight mb-8 hover:text-brand-charcoal transition-colors duration-150" data-id="element-1800" data-mp="2zu21je6afaop">
            {SUPPORT_PHONE_DISPLAY}
          </a>

          <div className="flex flex-col sm:flex-row gap-3" data-id="element-1801" data-mp="3sldevq56ijp0">
            <a href={`https://wa.me/${SUPPORT_PHONE_E164}`} target="_blank" rel="noopener noreferrer" className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-brand-charcoal text-white font-semibold rounded-xl hover:bg-gray-800 transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-charcoal" data-id="element-1802" data-mp="3du3dboo3c2iy">
              <MessageCircleIcon className="w-5 h-5" aria-hidden="true" data-id="element-1803" data-mp="1uw83kzsmel37" />
              Contactar soporte
            </a>
            <a href={`tel:+${SUPPORT_PHONE_E164}`} className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-gray-300 text-gray-800 font-semibold rounded-xl hover:bg-gray-50 transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-400" data-id="element-1804" data-mp="29l4ed4m2ac7i">
              <PhoneIcon className="w-5 h-5" aria-hidden="true" data-id="element-1805" data-mp="1pwlv13nqlt0q" />
              Llamar
            </a>
          </div>
        </div>

        <p className="text-center text-xs font-semibold tracking-[0.2em] text-gray-400 mt-8" data-id="element-1806" data-mp="1lu7cylrw6xai">
          NOIZA
        </p>
      </div>
    </main>;
}